import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let EditerComp;

class Editor extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: EditerComp };
      }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/editer-comp" */
            "../../../components/javascript/zcat-components/editer-comp"
        ).then(function(res) {
            EditerComp = res.EditerComp;
        }));

        
;
    }
}

export {Editor};

